import axios from "axios";

const instance = axios.create({
	baseURL: process.env.VUE_APP_API_URL
});


// 添加请求拦截器
instance.interceptors.request.use(
	function(config) {
		console.log(config)
		// 在发送请求之前做些什么
		// 在请求头中添加Authorization头部
		const token = localStorage.getItem('token');
		if (token) {
			var otherInfo = {
				'user-token': token,
			}
			config.headers = Object.assign(config.headers, otherInfo)
		}
		var contentType = {
			'content-type': 'application/x-www-form-urlencoded',
		}
		var userLang = {
			'user-lang': localStorage.getItem('lang') || 'zh',
		}
		config.headers = Object.assign(config.headers, contentType)
		config.headers.server = 1;
		config.headers = Object.assign(config.headers, userLang)

		return config;
	},
	function(error) {
		// 对请求错误做些什么
		return Promise.reject(error.data);
	}
);

// 添加响应拦截器
instance.interceptors.response.use(
	function(response) {
		if (response.status == 200) {
			if (response.data.code == 1) {
				// 对响应数据做点什么 console.log(11)
				return Promise.resolve(response.data);
			} else if (response.data.code == 450) {
			
				return Promise.reject(response.data);
			} else {
				return Promise.reject(response.data);
			}
		} else {
			return Promise.reject(response.data);
		}
	},
	function(error) {
		// 对响应错误做点什么
		return Promise.reject(error.data);
	}
);

export default instance;